import {omneticApi} from '@dms/api/base';

import {
  GetPersonnelOverviewApiResponse,
  GetPersonnelOverviewApiArg,
  personnelOverviewArgSchema,
  personnelOverviewResponseBodySchema,
} from './types';

export const personnelOverviewApi = omneticApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getPersonnelOverviewInterest: build.query<
      GetPersonnelOverviewApiResponse,
      GetPersonnelOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/personnel-overview/interest`,
        params: {branchId: queryArg.branchId},
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'PersonnelOverviewInterest', id: queryArg.branchId ?? 'ALL'},
      ],
      extraOptions: {
        requestSchema: personnelOverviewArgSchema,
        responseSchema: personnelOverviewResponseBodySchema,
      },
    }),
    getPersonnelOverviewBusinessCase: build.query<
      GetPersonnelOverviewApiResponse,
      GetPersonnelOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/personnel-overview/business-case`,
        params: {branchId: queryArg.branchId},
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'PersonnelOverviewBusinessCase', id: queryArg.branchId ?? 'ALL'},
      ],
      extraOptions: {
        requestSchema: personnelOverviewArgSchema,
        responseSchema: personnelOverviewResponseBodySchema,
      },
    }),
    getPersonnelOverviewWorkshopInterest: build.query<
      GetPersonnelOverviewApiResponse,
      GetPersonnelOverviewApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/workshop/interest/personnel-overview`,
        params: {branchId: queryArg.branchId},
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'PersonnelOverviewWorkshopInterest', id: queryArg.branchId ?? 'ALL'},
      ],
      extraOptions: {
        requestSchema: personnelOverviewArgSchema,
        responseSchema: personnelOverviewResponseBodySchema,
      },
    }),
  }),
});

export const {
  useGetPersonnelOverviewInterestQuery,
  useGetPersonnelOverviewBusinessCaseQuery,
  useGetPersonnelOverviewWorkshopInterestQuery,
} = personnelOverviewApi;
